import { ServiceStoreConfig } from "./types/ServiceStoreTypes";

// Import categorized service stores
import { crmStores } from "./serviceStores/crm.stores";
import { departmentStores } from "./serviceStores/department.stores";
import { financialStores } from "./serviceStores/financial.stores";
import { inventoryStores } from "./serviceStores/inventory.stores";
import { manufacturingStores } from "./serviceStores/manufacturing.stores";
import { organizationDataStores } from "./serviceStores/organization-data.stores";
import { payrollStores } from "./serviceStores/payroll.stores";
import { qcStores } from "./serviceStores/qc.stores";
import { schedulingStores } from "./serviceStores/scheduling.stores";
import { systemStores } from "./serviceStores/system.stores";
import { userStores } from "./serviceStores/user.stores";

/**
 * Main Service Store Configuration
 * Combines all categorized service stores into a single array
 *
 * Categories are organized based on the api-types directory structure:
 * - CRM: customers, components, vendors
 * - Department: departments
 * - Financial: quotes, quote-lines, tax-rates, wa-tax-lookup
 * - Inventory: inventory
 * - Manufacturing: products, bom-components, forms, labor-types, product-bom, product-labor, manhole-*
 * - Organization Data: projects, project-phases, project-phase-items, project-activity, project-documents, project-financials, project-milestones
 * - Scheduling: form-capacity, product-form-mappings, production-schedules, sales-orders, sales-order-lines
 * - System: api-services, notifications
 * - User: users
 * - Payroll: everee-embedded-sessions, everee-workers, everee-worker-data, etc.
 */
const serviceStores: ServiceStoreConfig[] = [
  ...crmStores,
  ...departmentStores,
  ...financialStores,
  ...inventoryStores,
  ...manufacturingStores,
  ...organizationDataStores,
  ...payrollStores,
  ...qcStores,
  ...schedulingStores,
  ...systemStores,
  ...userStores,
];

export default serviceStores;
